import { BankApplicationStatus } from '@/types/bankApplications';
import { getBankApplicationAccountStatusLabel } from '@/utils/bankAccountApplications';
import { Box, Chip } from '@mui/material';

type BankApplicationStatusLabelProps = {
  status: BankApplicationStatus;
  isSmall?: boolean;
};

export default function BankApplicationStatusLabel({
  status,
  isSmall = false,
}: BankApplicationStatusLabelProps) {
  const getStatusColor = (status: BankApplicationStatus) => {
    switch (status) {
      case BankApplicationStatus.DRAFT:
        return 'warning';
      case BankApplicationStatus.AWAITING_E_SIGN:
        return 'info';
      case BankApplicationStatus.SUBMITTED_BY_TEAMMATE:
      case BankApplicationStatus.SUBMITTED_BY_STAFF:
      case BankApplicationStatus.SUBMITTED:
        return 'info';
      case BankApplicationStatus.NEED_REVIEW:
        return 'primary';
      case BankApplicationStatus.COMPLETED:
        return 'success';
      case BankApplicationStatus.DECLINED:
        return 'error';
      default:
        return 'default';
    }
  };

  return (
    <Box>
      <Chip
        label={getBankApplicationAccountStatusLabel(status)}
        color={getStatusColor(status) as any}
        size={isSmall ? 'small' : 'medium'}
        variant="filled"
      />
    </Box>
  );
}
